import styled from 'styled-components'

const OrderStepContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  padding: 0;
`

OrderStepContainer.displayName = 'OrderStepContainer'
export default OrderStepContainer
